export default __webpack_public_path__ + "static/mssp_alert-c3a9c5913f1f1a3725fe9f26fad9273b.webp";